<template>
  <modal name="item-brand-link-modal" class="item-modal dgm-modal"
         :width="'80%'"
         :height="'80%'"
         @before-close="handlerBeforeClose"
         @before-open="handlerBeforeOpen"
         @opened="handlerOpened"
  >
      <div class="lookbook_item_wrap">
          <div class="li_title">상품등록</div>
          <button class="close_btn" @click="modalClose"></button>
          <brand-list-component :brandType="'linkBrandItem'"></brand-list-component>
          <div class="mt20 text-center">
              <el-button type="primary">등록</el-button>
          </div>
      </div>
  </modal>

</template>

<script>
import BrandListComponent from "@/components/brand/BrandListComponent";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins"
import EventBus from "@/mixins/event-bus";
export default {
  name: 'ItemBrandLinkModal',
  props: {},
  mixins: [alertMixins],
  components: {BrandListComponent},
  computed: {},
  provide() {
      return {
        selectModalData: this.selectData,
      }
  },
  data() {
      return {
        brandData: {}
      }
  },
  mounted() {

  },
  methods: {
      handlerBeforeOpen(event) {
          if (!util.isEmpty(event.params)) {
            
          }
      },
      handlerOpened() {
      },
      handlerBeforeClose() {
        this.brandData = {}
      },
      modalClose() {
          this.$modal.hide('item-brand-link-modal');
      },
      selectData(data) {
            this.brandData = data
            EventBus.$emit('runSelectBrand', this.brandData);
            EventBus.$emit('changeBrandDataStatus', this.brandData)
            EventBus.$emit('getLinkedBrand')
            this.modalClose();
        },

  }
}
</script>
